import React from "react";
import { CardContainer } from "../../../components/Card";
import { BarChart, LineChart } from "../../../components/Charts";

export default function LinkedInTab({ data }) {
    return (
        <CardContainer>
            <LineChart
                data={data}
                series={[
                    {
                        name: "LinkedIn",
                        key: "ttt_linkedin",
                    },
                ]}
                xKey="week"
                title="TTT LinkedIn Followers"
            />
            <BarChart
                data={data?.map((d) => ({
                    ...d,
                    ttt_linkedin_change: d.ttt_linkedin_change * 100,
                }))}
                series={[
                    {
                        name: "LinkedIn Followers",
                        key: "ttt_linkedin_change",
                    },
                ]}
                xKey="week"
                title="TTT LinkedIn Followers % Change"
                yFormatter={(v) => `${v / 100}`}
            />
        </CardContainer>
    );
}
